import { Flex } from 'app/components/design-system-components'
import CopilotTextLogo from 'app/components/display/smartdocs/logos/copilotAITextlogo'
import SmartDocsTextLogo from 'app/components/display/smartdocs/logos/smartDocsTextLogo'

function AIAnalyzerHeader({
  checkedItem = 0,
  foundItems = 0,
  isCopilot = true,
  withLearnMore = true,
  copilotSuggestions = 0,
}) {
  const logoToDisplay = isCopilot ? (
    <CopilotTextLogo
      withLearnMore={withLearnMore}
      copilotSuggestions={copilotSuggestions}
    />
  ) : (
    <SmartDocsTextLogo
      withLearnMore={withLearnMore}
      checkedItem={checkedItem}
      foundItems={foundItems}
    />
  )

  return (
    <>
      <Flex>{logoToDisplay}</Flex>
    </>
  )
}

export default AIAnalyzerHeader
